module.exports = __webpack_public_path__ + "static/fire-910c01893011a1c25d9f0cfe834f48b2.gif";